<template>
  <app-page-container
    :showNav="true"
    :navBackgroundLight="true"
    navBackgroundColor="#fbfbfb"
  >
    <div class="policy-container">
      <div class="policy">
        <div class="tabs flex">
          <div
            class="tab"
            v-for="(tab, index) in tabs"
            @click="setTabByURL(tab.url)"
            :key="index"
            :class="currentTab == tab.url ? 'selected-tab' : ''"
          >
            {{ tab.name }}
          </div>
        </div>
        <!-- <About v-if="currentTab == 'about'" /> -->
        <CommunityGuidelines v-if="currentTab == 'community-guidelines'" />
        <SafetyOnCofocus v-if="currentTab == 'safety-on-cofocus'" />
        <AcceptableUse v-if="currentTab == 'acceptableuse'" />
      </div>
    </div>
  </app-page-container>
</template>

<script>
import AppPageContainer from "@/components/AppPageContainer";
import CommunityGuidelines from "./CommunityGuidelines.vue";
import SafetyOnCofocus from "./SafetyOnCofocus.vue";

export default {
  name: "GuideBase",
  components: {
    AppPageContainer,
    CommunityGuidelines,
    SafetyOnCofocus,
  },
  data() {
    return {
      currentTab: "",

      tabs: [
        {
          url: "community-guidelines",
          name: "Community guidelines",
        },
        {
          url: "safety-on-cofocus",
          name: "Safety on Cofocus",
        },
      ],
    };
  },
  created() {
    this.currentTab = this.$route.params.page
      ? this.$route.params.page
      : "about";
  },
  methods: {
    setTabByURL(newTabURL) {
      this.currentTab = newTabURL ? newTabURL : "about";
      this.changeURL(newTabURL);
    },
    changeURL(tab) {
      let slash = `/help/`;
      slash = slash + tab;

      if (history.pushState) {
        history.pushState({}, null, slash);
      } else {
        // support for browsers not supporting pushState
        document.location.href = this.$route + slash;
      }
    },
  },
  watch: {
    "$route.params.page": {
      handler(newTabURL) {
        this.setTabByURL(newTabURL);
      },
      immediate: true,
    },
  },
};
</script>

<style>
@import "./styles/Policies.css";
</style>